import { Calendar } from "vanilla-calendar-pro";
import "vanilla-calendar-pro/styles/index.css";

const legendTypes = [
  {
    class: "invalidDate",
    label: "Not Valid",
    atts: 'data-vc-date data-vc-date-disabled'
  },
  {
    class: "validDate",
    label: "Valid",
    atts: 'data-vc-date'
  },
  {
    class: "blackoutDate",
    label: "Blackout",
    atts: 'data-vc-date'
  },
  {
    class: "today",
    label: "Current",
    atts: 'data-vc-date data-vc-date-today'
  }
];

const buildLegend = () => {
  let legendHTML =
    '<div class="legend d-flex align-items-center justify-content-between p-2 border border-light border-2 rounded">';

  legendTypes.forEach((type) => {
    legendHTML += `<div class="legend__item flex-column w-auto flex-grow-0 vc-date ${type.class}"
    ${type.atts}>
      <div class="vc-date__btn w-auto" aria-disabled="true" data-vc-date-btn>
        <span class="day">1</span>
      </div>
      <span class="text label-4 d-block">${type.label}</span>
    </div>`;
  });

  legendHTML += "</div>";
  return legendHTML;
};

const buildTimes = (validTimeString) => {
  if(validTimeString) {
    return `
    <div class="time-span label-1 text-primary text-center">
      ${validTimeString}
    </div>
    `;
  } else {
    return '';
  }
};

// Helper function to get the day of the week as a string
const getDayOfWeek = (date) => {
  return date.toLocaleDateString("en-US", { weekday: "long" });
};

// Helper function to format date as 'YYYY-MM-DD'
const formatDate = (date) => {
  return date.toISOString().split("T")[0];
};

// Function to get the valid dates based on valid days of the week
const getValidDates = (startDate, endDate, validDays) => {
  if(validDays == 'null' || validDays.length == 0) {
    validDays = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
  }

  const today = new Date();
  const start = new Date(startDate);
  const end = new Date(endDate);
  const startValid = start > today ? start : today;
  let validDates = [];

  while (startValid <= end) {
    const dayOfWeek = getDayOfWeek(startValid);
    const formattedDate = formatDate(startValid);

    if (validDays.includes(dayOfWeek)) {
      validDates.push(formattedDate);
    }
    startValid.setDate(startValid.getDate() + 1);
  }
  return validDates;
};

const buildOptions = (validDates, blackoutDates, validTimeString) => {
  let options = {
    disableAllDates: true,
    enableDates: validDates,
    selectionDatesMode: false,
    selectedWeekends: [],
    selectedTheme: "light",
    onCreateDateEls(self, dateEl) {
      let calDate = dateEl.getAttribute("data-vc-date");
      if (blackoutDates.includes(calDate)) {
        dateEl.classList.add("blackoutDate");
      } else if (validDates.includes(calDate)) {
        dateEl.classList.add("validDate");
      }
    },
    firstWeekday: 0,
    styles: {
      arrowPrev: "nav-arrow vc-arrow_prev",
      arrowNext: "nav-arrow vc-arrow_next",
      calendar: "vc rounded shadow",
    },
    layouts: {
      default: `<div class="vc-header" data-vc="header" role="toolbar" aria-label="Calendar Navigation">
        <#ArrowPrev />
        <div class="vc-header__content" data-vc-header="content">
           <#Month /><#Year />
        </div>
        <#ArrowNext />
      </div>
      <div class="vc-wrapper" data-vc="wrapper">
        <#WeekNumbers />
        <div class="vc-content" data-vc="content">
          <#Week />
          <#Dates />
        </div>
      </div>
      <div class="vc-footer" data-vc="footer">
        ${buildTimes(validTimeString)}
        ${buildLegend()}
      </div>`,
    },
  };
  return options;
};

export const initCalendar = (
  startDateRaw,
  endDateRaw,
  validDaysOfWeek,
  blackoutDates,
  validTimeString
) => {
  const validDates = getValidDates(startDateRaw, endDateRaw, validDaysOfWeek);
  const options = buildOptions(validDates, blackoutDates, validTimeString);
  const calendar = new Calendar("#calendar", options);
  calendar.init();
};
